/** Nazivi načina plaćanja — šifrarnik `finance.invoice_payment_methods`. */
export const PAYMENT_METHOD_LABELS: Record<string, string> = {
  transakcijski: "Transakcijski račun",
  gotovina: "Gotovina",
  kartice: "Kartice",
  ostalo: "Ostalo",
};
